/* eslint react-hooks/rules-of-hooks: "warn" */
import { getHotkeyMenu, HOTKEY_TYPE, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { ContextMenuPluginDependency } from '../../../dependency';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer, isImageEditor }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    let disabled = !layer;

    if (isImageEditor && disabled) return null;
    if (isImageEditor && activeLayer) {
        disabled = framework.getBehavior(activeLayer)?.checkDisableCut?.(activeLayer) ?? false;
    }
    if (!disabled && pickLayer) {
        disabled = !framework.checkPossibleCut(pickLayer);
    }

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.cut),
        type: HOTKEY_TYPE.cut,
        desc: getHotkeyMenu(HOTKEY_TYPE.cut),
        onClick: () => {
            framework.getInstance(ContextMenuPluginDependency).onCut();
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 1,
    sort: 5,
    render,
} as IExportContextMenuItem;
